module.exports = "/_next/static/images/bd878e08c9b358d8141f924cbff57ca8-wow@2x.png.webp";